var map = {
	"./barclays/BrandReports.json": 1212,
	"./cb911/BrandReports.json": 1213,
	"./choiceHotels/BrandReports.json": 1214,
	"./lvmh/BrandReports.json": 1215,
	"./outpayce/BrandReports.json": 1216,
	"./sofi/BrandReports.json": 1217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1211;